import { render } from "./GoBackButton.vue?vue&type=template&id=11e24cb6&scoped=true&ts=true"
import script from "./GoBackButton.vue?vue&type=script&lang=ts"
export * from "./GoBackButton.vue?vue&type=script&lang=ts"

import "./GoBackButton.vue?vue&type=style&index=0&id=11e24cb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e24cb6"]])

export default __exports__